import React from 'react';
import styles from './FeedListItem.module.css';

const linkItem = (name, onClick) => {
  return (
    <span className={`namesAndObjects ${styles.name}`} onClick={onClick}>
      {`> ${name || ''}`}
    </span>
  );
};

function ListItemTitle(
  history,
  navigating,
  type,
  verb,
  event,
  group,
  challenge,
) {
  if (type === 'event') {
    if (verb === 'create') return `added an event`;
    else if (verb === 'going' || verb === 'interested') return `is ${verb}`;
    else if (verb === 'checked_in') return `checked into`;
    else if (verb === 'update') return 'updated an event';
    else if (verb === 'cancel') return 'canceled an event';
  } else if (type === 'post' || type === 'challenge' || type === 'group') {
    if (event?.name) {
      if (navigating) return `posted on ${event.name || ''}`;
      return linkItem(event.name, () => history.push(`/events/${event.id}`));
    } else if (group?.name) {
      if (navigating) return `posted on ${group.name || ''}`;
      return linkItem(group.name, () => history.push(`/groups/${group.id}`));
    } else if (challenge?.name) {
      if (navigating) return `posted on ${challenge.name || ''}`;
      return linkItem(challenge.name, () =>
        history.push(`/challenges/${challenge.id}`),
      );
    } else {
      return 'posted';
    }
  }
}

export default ListItemTitle;
